var inspectoresAdmin = angular.module('posicionamientosAdmin');

inspectoresAdmin.controller('posicionamientosAdminController', ['$scope', '$location', '$routeParams', 'posicionamientosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $location, $routeParams, posicionamientosAdminService, authenticationInfo, authenticationService) {

    $scope.authentication = authenticationInfo;

    $scope.inspeccionId = $routeParams.id;

    posicionamientosAdminService.getPosicionamientosInspeccion($scope.inspeccionId)
            .then(function (response) {
                var data = response.data;
                $scope.posicionamientos = data;
            });

    //$scope.verInspector = function (idInspector) {
    //    $location.path('/admin/editarPosicionamiento/' + idInspector);
    //        //$location.path('/Admin/' + idUsuario);

    //    };

    $scope.editarPosicionamiento = function () {
        posicionamientosAdminService.guardarPosicionamientos($scope.posicionamientos)
            .then(function (response) {
                var data = response.data;
                $scope.posicionamientos = data;
                alert("Los posicionamientos han sido guardados correctamente");
            });
    }

    $scope.crearPosicionamiento = function (inspeccionId) {
        $location.path('/admin/posicionamiento/nuevo' + inspeccionId);
    }

    $scope.posicionamientosSeleccionados = ""
    $scope.eliminarPosicionamientos = function () {
        var confirmado = confirm('¿Desea eliminar los posicionamientos seleccionados?')
        if (confirmado) {
            angular.forEach($scope.posicionamientos, function (posicionamiento) {
                if (posicionamiento.Selected) {
                    if ($scope.posicionamientosSeleccionados != "") {
                        $scope.posicionamientosSeleccionados = $scope.posicionamientosSeleccionados + "," + posicionamiento.Id
                    } else {
                        $scope.posicionamientosSeleccionados = posicionamiento.Id
                    }

                };
            });
            posicionamientosAdminService.eliminarPosicionamientos($scope.posicionamientosSeleccionados).then(function (response) {
                var result = response.data;
                alert(result);
                $scope.posicionamientosSeleccionados = [];
                posicionamientosAdminService.getPosicionamientosInspeccion($scope.inspeccionId)
                    .then(function (response) {
                        var data = response.data;
                        $scope.posicionamientos = data;
                    });
            }).catch(function (response) {
                $scope.error = posicionamientosAdminService.obtenerPrimerErrorModelState(response.data);
                alert($scope.error);
            });
        }
    };

        $scope.seleccionarTodos = function () {
            if (!$scope.SeleccionadosTodos) {
                $scope.SeleccionadosTodos = true;
            } else {
                $scope.SeleccionadosTodos = false;
            }
            angular.forEach($scope.posicionamientos, function (posicionamiento) {
                posicionamiento.Selected = $scope.SeleccionadosTodos;
            });

    };

    $scope.crearPosicionamiento = function () {
        $location.path('/admin/posicionamientos/nuevo/' + $scope.inspeccionId);
    }

    $scope.gestionPosicionamientos = function () {
        $location.path('/admin/posicionamientosAdmin');
    }

    }]);